import React, { useState } from "react";
import * as Models from "../../../Models";
import RequestNewAssetModal from "./RequestNewAssetModal";
import SearchAssetBySerialNumberModal from "./SearchAssetBySerialNumberModal";
import LinkExistingAssetToProject from "./LinkExistingAssetToProject";
import filterItemsStore from "../../../Store/filterItems";

interface RequestNewAssetContainerProps {
    showLinkAddAsset: boolean;
    showRequestNewAsset: boolean;
    match: Models.Match;
}

export default function RequestNewAssetContainer(
    props: RequestNewAssetContainerProps
) {
    /*
     * 0 = close
     * 1 = open searchasssetbyserialnumbermodal
     * 2 = open requestnewassetmodal
     * 3 = open linkExistingAssetModal
     */
    const [open, setOpen] = useState(0);
    const { getActiveDetail } = filterItemsStore();
    const activeDetail: Models.ActiveDetail = getActiveDetail(
        props.match.params
    );

    const openModal = () => {
        setOpen(1);
    };

    const closeModal = () => {
        setOpen(0);
    };

    const handleOpenModal = (openState: number) => {
        setOpen(openState);
    };

    const openLinkExistingAssetModal = () => {
        setOpen(3);
    };

    return (
        <>
            <div className="RequestNewAsset-button-container">
                {props.showRequestNewAsset && (
                    <button className="btn btn-primary" onClick={openModal}>
                        Request new asset
                    </button>
                )}
            </div>
            {props.showLinkAddAsset && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                >
                    <button className="btn btn-primary" onClick={openModal}>
                        Add new asset
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={openLinkExistingAssetModal}
                    >
                        Link existing asset
                    </button>
                </div>
            )}

            {open === 1 && (
                <SearchAssetBySerialNumberModal
                    open={open}
                    // showRequestNewAsset={props.showRequestNewAsset}
                    handleOpenModal={handleOpenModal}
                    onClose={closeModal}
                ></SearchAssetBySerialNumberModal>
            )}
            {open === 2 && (
                <RequestNewAssetModal
                    showLinkAddAsset={props.showLinkAddAsset}
                    activeDetail={activeDetail}
                    open={!!open}
                    onClose={closeModal}
                />
            )}
            {open === 3 && (
                <LinkExistingAssetToProject
                    projectId={activeDetail?.detail?.description}
                    siteName={activeDetail?.detail?.siteName}
                    alternativeProjectId={activeDetail?.detail?.id}
                    isOpen={open === 3}
                    onClose={closeModal}
                ></LinkExistingAssetToProject>
            )}
        </>
    );
}
